module.exports = __webpack_public_path__ + "static/recipe-collect-6-bd20448615cc53944fbbb915c2940d74.jpeg";